exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3inPWS9XBGO5lD{background-color:#faf3c0;border-radius:3px;color:#5e6c84;font-size:12px;line-height:16px;margin-bottom:8px;padding:4px 8px}._1J9mbVsbRyVDVP{color:#5e6c84}", ""]);

// exports
exports.locals = {
	"advancedChecklistsBetaInfo": "_3inPWS9XBGO5lD",
	"feedback": "_1J9mbVsbRyVDVP"
};